export default __webpack_public_path__ + "static/media/logo.055196d9.png";